import styled from 'styled-components'

import Body from '../body'

export default styled(Body)`
  margin-top: ${({ theme }) => theme.spacing.medium};
`
